import React, { useState } from 'react';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { getAuth } from 'firebase/auth';
import { Send, X } from 'lucide-react';
import './GeneralFeedbackModal.css';

const GeneralFeedbackModal = ({ isOpen, onClose, user }) => {
  const [feedbackType, setFeedbackType] = useState('improvement');
  const [feedback, setFeedback] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const resetState = () => {
    setFeedbackType('improvement');
    setFeedback('');
    setSubmitted(false);
  };

  const handleClose = () => {
    if (isSubmitting) return;
    resetState();
    onClose?.();
  };

  const handleSubmit = async () => {
    const trimmed = feedback.trim();
    if (!trimmed) return;

    try {
      setIsSubmitting(true);
      const auth = getAuth();
      const currentUser = user || auth.currentUser;
      
      await addDoc(collection(db, 'betaFeedback'), {
        userId: currentUser?.uid || null,
        email: currentUser?.email || null,
        name: currentUser?.displayName || null,
        userType: 'brand',
        feedbackType,
        feedback: trimmed,
        createdAt: serverTimestamp(),
      });
      setSubmitted(true);
      setFeedback('');
    } catch (error) {
      console.error('Failed to submit feedback:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && event.metaKey) {
      handleSubmit();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="general-feedback-overlay" onClick={handleClose}>
      <div className="general-feedback-modal" onClick={(e) => e.stopPropagation()}>
        <div className="general-feedback-header">
          <div>
            <h3>Share Feedback</h3>
            <p>Help us smooth out the beta by flagging problems or ideas.</p>
          </div>
          <button type="button" className="general-feedback-close" onClick={handleClose} aria-label="Close feedback">
            <X size={20} />
          </button>
        </div>
        <div className="general-feedback-body">
          <label className="general-feedback-field">
            <span>What kind of feedback is this?</span>
            <select value={feedbackType} onChange={(e) => setFeedbackType(e.target.value)}>
              <option value="improvement">Improvement idea</option>
              <option value="bug">Problem / bug</option>
              <option value="other">Something else</option>
            </select>
          </label>
          <label className="general-feedback-field">
            <span>Tell us more</span>
            <textarea
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Describe the issue or improvement you'd like to see..."
              rows={5}
            />
          </label>
          {submitted && (
            <div className="general-feedback-success">Thanks! We received your feedback.</div>
          )}
        </div>
        <div className="general-feedback-actions">
          <button type="button" className="general-feedback-cancel" onClick={handleClose} disabled={isSubmitting}>
            Cancel
          </button>
          <button
            type="button"
            className="general-feedback-submit"
            onClick={handleSubmit}
            disabled={!feedback.trim() || isSubmitting}
          >
            <Send size={16} />
            <span>{isSubmitting ? 'Sending...' : 'Send Feedback'}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default GeneralFeedbackModal;



